<div class="container">
    <div class="card">
        <h4>
            Disclaimer
        </h4>
        <p>EarthEye is a Multi-tasking Platform</p>
    </div>
</div>